module.exports = __webpack_public_path__ + "static/media/angle-double-right.56156728.svg";